import { equal } from '@ember/object/computed';
import Em from 'ember';
export default Em.Mixin.create({
  canAlign: true,
  isCentered: equal('align', 'center')
});